import { Outlet } from '@tanstack/react-router';
import OrgInfo from '@/features/public/booking/components/OrgInfo.tsx';
import { waitlistPublicRoute } from '@/features/public/waitlist/routes/waitlistPublicRoutes.ts';

const WaitlistLayout = () => {
  const { tourBasicInfo } = waitlistPublicRoute.useLoaderData();

  return (
    <div className="lg:grid lg:grid-cols-[1fr_minmax(0,600px)_1fr] lg:gap-8 lg:px-4">
      <div className="hidden justify-end lg:flex lg:pt-20">
        <OrgInfo tourBasicInfo={tourBasicInfo} />
      </div>

      <div className="mt-10 space-y-2 px-4 lg:mt-20 lg:px-0">
        <div className="mb-6 space-y-1">
          <div className="mb-4 lg:hidden">
            <OrgInfo tourBasicInfo={tourBasicInfo} />
          </div>
          <h1 className="text-2xl font-semibold text-base-text">
            Lista rezerwowa na {tourBasicInfo.tourName}
          </h1>
          <div className="text-neutral-600">
            Zapisz się na listę rezerwową, a skontaktujemy się z Tobą gdy zwolni
            się miejsce.
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default WaitlistLayout;
